<template>
	<div class="order-detail" v-if="detail">
		<Tabs :tabs="tabs" :cur="curIndex" @changeTab="changeTab"></Tabs>
		<div class="detail" v-show="curIndex == 0">
			<div class="item-box">
				<div class="header">
					<div>
						<span>订单号：{{ detail.order_no }}</span>
						<span>下单时间：{{ detail.create_time }}</span>
					</div>
				</div>
				<div class="order-info">
					<div class="left">
						<div class="info">收件人：{{ detail.consignee }}</div>
						<div class="info">联系方式：{{ detail.mobile }}</div>
						<div class="info">收货地址：{{ detail.province }}{{ detail.city }}{{ detail.zone }}{{ detail.address }}</div>
					</div>
					<div class="right">
						<div class="top">
							<div class="info" v-if="detail.pay_type_name">
								<div class="w60">支付方式：</div>
								<div class="w40">{{ detail.pay_type_name }}</div>
							</div>

							<div class="info" v-for="(item,index) in detail.totals" :key="index">
								<div class="w60">{{ item.title }}：</div>
								<div class="w40">￥{{ item.total }}</div>
							</div>
							<div class="info" v-if="detail.pay_type_name">
								<div class="w60">商品金额：</div>
								<div class="w40 " >￥{{ detail.total }}</div>
							</div>
						</div>

						<div class="info align-center"  v-if="detail.payment_info && detail.payment_info.order_no_arr.length > 1">
							<div class="w60">支付信息：</div>
							<div class="w40">
								<div>合并支付</div>
								<div class="" v-for="(item,index) in detail.payment_info.order_no_arr" :key="index">
									{{ item.order_no }}
								</div>
							</div>
						</div>
						<div class="info" v-if="detail.payment_info">
							<div class="w60">优惠金额:</div>
							<div class="w40">￥{{ detail.payment_info.discount_money }}</div>
						</div>
						<div class="info" v-if="detail.payment_info">
							<div class="w60">实付金额:</div>
							<div class="w40 real-pay">￥{{ detail.payment_info.money }}</div>
						</div>

					</div>
				</div>
			</div>
			<div class="item-box">
				<div class="header">
					<div>{{ detail.status_name | orderStatusName }}</div>
					<div class="status-action-box" v-if="detail.command">
						<div class="action action-pay" v-if="detail.command.includes('pay')" @click.stop="go2pay(detail.order_id)">去付款
						</div>
						<div class="action action-pay" v-if="detail.command.includes('refund')" @click.stop="go2refund">
							退款</div>
						<div class="action action-pay" v-if="detail.command.includes('receive_confirm')"
							@click.stop="go2confirm">确认收货</div>
						<div class="action action-pay" v-if="detail.command.includes('comment')"
							@click.stop="go2comment">确认收货</div>
						<div class="action action-cancel" v-if="detail.command.includes('cancel')"
							@click.stop="go2cancel">取消订单</div>
					</div>
				</div>
				<div class="goods-box">
					<div class="desc">
						<div class="order">商品信息</div>
						<div class="status">单价</div>
						<div class="date">数量</div>
						<div class="pay">小计</div>
					</div>
					<div class="logs">
						<template v-if="detail.order_type == 5">
							<div class="item">
								<div class="order">
									<img :src="detail.design_mtm.design_data.effect_picture" />
									<div class="p-name">{{ detail.design_mtm.design_data.category.category_name_cn }}
									</div>
								</div>
								<div class="status">￥{{ detail.design_mtm.price}}</div>
								<div class="date">{{ detail.design_mtm.quantity }}</div>
								<div class="pay">￥{{ detail.design_mtm.price * detail.design_mtm.quantity  }}</div>
							</div>
						</template>


					</div>
				</div>
			</div>
			<div class="item-box" v-if="refund_list.length>0">
				<div class="header">
					<div>返修进度</div>
				</div>
				<div class="logistics">
					<div class="left flex-wrap">
						<div class="turn-list flex" style="width: 100%" >
							<div class="turn-item" :class="{active:k==current_refund_index}" v-for="(v,k) in refund_list" @click="current_refund_index=k">
								返修-{{k+1}}
							</div>
						</div>
						<div>
							<div class="logistics-name">
								<span>返修单号：</span>
								<span>{{refund_list[current_refund_index].refund_no}}</span>
							</div>
							<div class="logistics-name">
								<span>申请时间：</span>
								<span>{{refund_list[current_refund_index].apply_time}}</span>
							</div>
						</div>

					</div>
					<div class="right">
						<Timeline>
							<Timeline-item v-for="(vv,kk) in refund_list[current_refund_index].flow.reverse()" :key="`re`+kk">
								<p class="time">{{vv.date}}-{{vv.status_name}}</p>
								<p class="content">{{vv.brief}}</p>
							</Timeline-item>

						</Timeline>

					</div>
				</div>
			</div>
			<div class="item-box" style="display: none;">
				<div class="header">
					<div>物流追踪</div>
				</div>
				<div class="logistics">
					<div class="left">
						<img src="../../assets/images/user/logistics.png" />
						<div>
							<div class="logistics-name">
								<span>物流公司：</span>
								<span>顺丰速运</span>
							</div>
							<div class="logistics-name">
								<span>快递单号：</span>
								<span>7084145759965</span>
							</div>
						</div>

					</div>
					<div class="right">
						<Timeline>
							<Timeline-item>
								<p class="time">2021-08-11</p>
								<p class="content">快件在【东莞虎门集散中心】已装车，准备发往下一站</p>
							</Timeline-item>
							<Timeline-item>
								<p class="time">2021-08-11</p>
								<p class="content">快件在【东莞虎门集散中心】</p>
							</Timeline-item>
							<Timeline-item>
								<p class="time">2021-08-11</p>
								<p class="content">快件已发车</p>
							</Timeline-item>

						</Timeline>

					</div>
				</div>
			</div>
		</div>
		<div class="data-box" v-show="curIndex == 1">
			<div class="data-item" v-if="detail">
				<div class="header">整体说明</div>
				<div class="data-content">
					<div class="item  padding-20" style="width:  335px;">
						<img class="p-img" :src='detail.design_mtm.design_data.effect_picture' />
						<div class="margin-left-10">
							<div class="content">
								<span class="title">款式名称：</span>
								<span class="value">{{ detail.design_mtm.design_data.category.category_name_cn }}</span>
							</div>
							<div class="content">
								<span class="title">数 量：</span>
								<span class="value">{{ detail.design_mtm.quantity }}</span>
							</div>
							<div class="content">
								<span class="title">穿衣喜好：</span>
								<span
									class="value">{{ detail.design_mtm.design_data.clothes_preference|get_mtm_preference}}</span>
							</div>
							<div class="content">
								<span class="title">量体方式：</span>
								<span
									class="value">{{detail.design_mtm.design_data.measure_type| get_mtm_measure_type }}</span>
							</div>
						</div>
					</div>
					<div class="item" style="width:  309px;">
						<div class="margin-left-10">
							<div class="content">
								<div class="title">面料颜色：</div>
								<div class="value">{{ detail.design_mtm.design_data.fabric_list.color.color_name_cn }}</div>
							</div>
							<div class="content">
								<div class="title">面料材质：</div>
								<div class="value">
									{{ detail.design_mtm.design_data.fabric_list.material.fabric_name_cn }}
								</div>
							</div>
							<div class="content">
								<div class="title">个人备注：</div>
								<div class="value">{{ detail.design_mtm.design_data.profile.remark }}</div>
							</div>
						</div>
					</div>
					<div class="item" style="width: 265px;">
						<div class="margin-left-10">
							<div class="content">
								<span class="title">个人照片：</span>
							</div>
							<div class="content-img">
								<a  v-for="(item,index) in detail.design_mtm.design_data.profile.image" target="_blank" :href="item">
									<img class="img" :key="index" :src="item" />
								</a>
							</div>

						</div>
					</div>
				</div>
			</div>

			<div class="data-item">
				<div class="header">客户信息</div>
				<div class="data-part" style="padding: 20px;">
					<div class="content" style="width: 33%; float: left;margin-bottom: 10px;">
						<span class="title">姓名：</span>
						<span class="value">{{ detail.design_mtm.design_data.profile.name }}</span>
					</div>
					<div class="content" style="width: 33%; float: left;margin-bottom: 10px;">
						<span class="title">手机：</span>
						<span class="value">{{ detail.design_mtm.design_data.profile.mobile }}</span>
					</div>
					<div class="content" style="width: 33%; float: left;margin-bottom: 10px;">
						<span class="title">生日：</span>
						<span class="value">{{ detail.design_mtm.design_data.profile.birthday }}</span>
					</div>
					<div class="content" style="width: 33%; float: left;margin-bottom: 10px;">
						<span class="title">性别：</span>
						<span class="value">{{ detail.design_mtm.design_data.profile.sex|sex2word }}</span>
					</div>
					<div class="content" style="width: 33%; float: left;margin-bottom: 10px;">
						<span class="title">身高：</span>
						<span class="value">{{ detail.design_mtm.design_data.profile.height }}</span>
					</div>
					<div class="content" style="width: 33%; float: left;margin-bottom: 10px;">
						<span class="title">体重：</span>
						<span class="value">{{ detail.design_mtm.design_data.profile.weight }}</span>
					</div>
					<div class="clear"></div>
				</div>
			</div>

			<div class="data-item">
				<div class="header">部件设计</div>
				<div class="data-part" style="padding: 20px;">

					<div class="content" style="width: 33%; float: left;margin-bottom: 10px;"
						v-for="(item,key) in detail.design_mtm.design_data.part_code_list" :key="key">
						<span class="title">{{ item.part_key }}：</span>
						<span class="value">{{ item.option_name }}</span>
					</div>
					<div class="clear"></div>
				</div>
			</div>
			<div class="data-item">
				<div class="header">深度设计</div>
				<div class="data-part" style="padding: 20px;">

					<div class="content" style="width: 33%; float: left;margin-bottom: 10px;"
						 v-for="(item,key) in detail.design_mtm.design_data.deep_code" :key="key">
						<span class="title">{{ item.deep_name }}：</span>
						<span class="value">{{ item.option_name }}</span>
					</div>
					<div class="clear"></div>
				</div>
			</div>
			<div class="data-item">
				<div class="header">撞色/拼接</div>
				<div class="data-part" style="padding: 20px;">
					<div class="content" style="width: 33%; float: left;margin-bottom: 10px;">
						<span class="title">撞色：</span>
						<span class="value">{{detail.design_mtm.design_data.zs_buwei_list.map(v=>v.text).join(',')}}</span>
					</div>
					<div class="content" style="width: 33%; float: left;margin-bottom: 10px;">
						<span class="title">拼接：</span>
						<span class="value">{{Object.values(detail.design_mtm.design_data.pj_buwei_list).map(v=>v.text).join(',')}}</span>
					</div>
					<div class="clear"></div>
				</div>
			</div>
			<div class="data-item">
				<div class="header">辅料设计</div>
				<div class="data-part" style="padding: 20px;">

					<div class="content" style="width: 33%; float: left;margin-bottom: 10px;"
						 v-for="(item,key) in detail.design_mtm.design_data.accessory_code" :key="key">
						<span class="title">{{ item.deep_name }}：</span>
						<span class="value">{{ item.option_name }}</span>
					</div>
					<div class="clear"></div>
				</div>
			</div>
			<div class="data-item">
				<div class="header">插花眼设计</div>
				<div class="data-part" style="padding: 20px;">

					<div class="content" style="width: 33%; float: left;margin-bottom: 10px;"
						 v-for="(item,key) in detail.design_mtm.design_data.flower_code" :key="key">
						<span class="title">{{ item.deep_name }}：</span>
						<span class="value">{{ item.option_name }}</span>
					</div>
					<div class="clear"></div>
				</div>
			</div>
			<div class="data-item" v-show="detail.design_mtm.design_data.measure_type===3">
				<div class="header">版型调整</div>
				<div class="data-part" style="padding: 20px;">

					<div class="content" style="width: 33%; float: left;margin-bottom: 10px;"
						 v-for="(item,key) in detail.design_mtm.design_data.category.bxtz" :key="key">
						<span class="title">{{ item.field_name_cn }}：</span>
						<span class="value">{{ getBxtzValue(item.field_key) }}</span>
					</div>
					<div class="clear"></div>
				</div>
			</div>
			<div class="data-item" v-show="detail.design_mtm.design_data.measure_type===4">
				<div class="header">体型选择</div>
				<div class="data-part" style="padding: 20px;">

					<div class="content" style="width: 33%; float: left;margin-bottom: 10px;"
						 v-for="(item,key) in detail.design_mtm.design_data.category.txxz" :key="key">
						<span class="title">{{ item.field_name_cn }}：</span>
						<span class="value">{{ getTxxzValue(item.field_key) }}</span>
					</div>
					<div class="clear"></div>
				</div>
			</div>
			<div class="data-item">
				<div class="header">体态特征</div>
				<div class="data-part" style="padding: 20px;">

					<div class="content" style="width: 33%; float: left;margin-bottom: 10px;"
						 v-for="(item,key) in detail.design_mtm.design_data.category.body" :key="key">
						<span class="title">{{ item.field_name_cn }}：</span>
						<span class="value">{{ getBodyValue(item.field_key) }}</span>
					</div>
					<div class="clear"></div>
				</div>
			</div>
			<div class="data-item">
				<div class="header">成衣尺寸</div>
				<div class="data-part" style="padding: 20px;" >
					<div class="content" style="width: 33%; float: left;margin-bottom: 10px;"
						v-for="(item,key) in detail.design_mtm.design_data.category.figure" :key="key">
						<span class="title">{{ item.field_name_cn }}：</span>
						<span class="value">{{ getFigureValue(item.field_key) }}</span>
					</div>
					<div class="clear"></div>
				</div>
			</div>


			<div class="data-item">
				<div class="header">个性设计</div>
				<div class="data-part" style="padding: 20px;">
					<div v-for="(vv, kk) in detail.design_mtm.design_data.customize_data">
						<template v-if="vv.type===1">
							<div class="content" style="width: 25%; float: left;margin-bottom: 10px;">
								<span class="title">部位：</span>
								<span class="value">{{ vv.name }}</span>
							</div>
							<div class="content" style="width: 25%; float: left;margin-bottom: 10px;">
								<span class="title">类型：</span>
								<span class="value">文字</span>
							</div>
							<div class="content" style="width: 25%; float: left;margin-bottom: 10px;">
								<span class="title">工艺：</span>
								<span class="value">{{vv.print_type|print_type_text}}</span>
							</div>
							<div class="content" style="width: 25%; float: left;margin-bottom: 10px;">
								<span class="title">内容：</span>
								<span class="value">{{ vv.text_value }}</span>
								<img class="color-box margin-left-10" :src="vv.text_color_image"/>
							</div>
						</template>
						<template v-else>
							<div class="content" style="width: 25%; float: left;margin-bottom: 10px;">
								<span class="title">部位：</span>
								<span class="value">{{ vv.name }}</span>
							</div>
							<div class="content" style="width: 25%; float: left;margin-bottom: 10px;">
								<span class="title">类型：</span>
								<span class="value">图案</span>
							</div>
							<div class="content" style="width: 25%; float: left;margin-bottom: 10px;">
								<span class="title">工艺：</span>
								<span class="value">{{vv.print_type|print_type_text}}</span>
							</div>
							<div class="content" style="width: 25%; float: left;margin-bottom: 10px;">
								<span class="title">内容：</span>
								<img class="color-box margin-left-10" :src="vv.image_value"/>
							</div>
						</template>
					</div>
					<div class="clear"></div>
				</div>
			</div>

			<div class="data-item">
				<div class="header">客供文件</div>
				<div class="data-part" style="padding: 20px;" >
					<template v-for="v in detail.customer_wanted">
						<a :href="v" target="_blank">
							<img :src="v" alt="" class="wanted">
						</a>
					</template>
				</div>
			</div>

			<div class="data-item" v-if="detail.design_mtm.design_data.profile">
				<div class="header">订单备注</div>
				<div class="data-part" style="padding: 20px;" >
					{{ detail.comment }}
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	import {
		getOrderDetail,
		ApplyDetail as RefundApplyDetail
	} from "@/api"
	import Tabs from "@/components/Tabs.vue";
	export default {
		name: 'OrderDetail',
		components: {
			Tabs
		},
		data() {
			return {
				curIndex: 0,
				tabs: [{
						index: 0,
						title: '订单详情'
					},
					{
						index: 1,
						title: '数据详情'
					},
				],
				detail: null,
				refund_list: [],
				current_refund_index: 0,
			};
		},
		created() {
			this.getDetail()
			RefundApplyDetail({
				order_id: this.$route.query.order_id
			}).then((res) => {
				this.refund_list = res.data
			})
		},
		methods: {
			getDetail() {
				getOrderDetail({
					order_id: this.$route.query.order_id
				}).then((res) => {
					this.detail = res.data

				})
			},
			changeTab(index) {
				this.curIndex = index
			},
			getFigureValue(key) {
				if(this.detail.design_mtm.design_data.complete_size) {
					return this.detail.design_mtm.design_data.complete_size[key]
				}
				return ''
			},
			getBodyValue(key) {
				if(this.detail.design_mtm.design_data.body_feature) {
					return this.detail.design_mtm.design_data.body_feature[key]
				}
				return ''
			},
			getTxxzValue(key) {
				if(this.detail.design_mtm.design_data.txxz_feature) {
					return this.detail.design_mtm.design_data.txxz_feature[key]
				}
				return ''
			},
			getBxtzValue(key) {
				if(this.detail.design_mtm.design_data.bxtz_feature) {
					return this.detail.design_mtm.design_data.bxtz_feature[key]
				}
				return ''
			},
			go2pay(order_id) {
				this.$router.push({
					name: 'Paytype',
					query: {id:order_id}
				})
			}
		},
		filters: {
			sex2word: function (val) {
				return val == 1 ? '男' : '女'
			}
		}
	}
</script>

<style lang="scss" scoped>
	.order-detail {
		padding: 20px;
		background: #FFFFFF;
		border: 1px solid #EEEEEE;

		.detail {
			margin-top: 20px;

			.item-box {
				background: #FFFFFF;
				border: 1px solid #EEEEEE;
				margin-bottom: 10px;

				.header {
					height: 40px;
					background: #F5F5F5;
					display: flex;
					justify-content: space-between;
					align-items: center;
					color: #333333;
					font-size: 14px;
					padding: 0 20px;

					span {
						margin-right: 40px;
					}

					.status-action-box {
						display: flex;

						.action {
							width: 72px;
							height: 30px;
							line-height: 30px;
							border-radius: 3px;
							text-align: center;
							margin-left: 20px;
							font-weight: bold;
							cursor: pointer;
						}

						.action-pay {
							background: #0F114A;
							color: #EDD4AC;
						}

						.action-cancel {
							border: 1px solid #0F114A;
							background: #FFFFFF;
							color: #0F114A;
						}
					}
				}

				.goods-box {
					padding: 0 20px;

					.desc {
						height: 44px;
						display: flex;
						align-items: center;
						font-size: 13px;
						color: #333333;
						border-bottom: 1px dashed #DDDDDD;

						div {
							padding-left: 20px;
						}
					}

					.desc,
					.logs {
						.order {
							width: 500px;
						}

						.status {
							width: 120px;
						}

						.date {
							width: 170px;
						}

						.pay {
							width: 120px;
						}
					}

					.logs {
						font-size: 15px;
						color: #666666;
						padding: 20px 0;

						.item:last-child {
							border: none;
						}

						.item {
							display: flex;
							align-items: center;
							border-bottom: 1px solid #DDDDDD;

							div {
								padding-left: 20px;
							}

							.order {
								display: flex;
								align-items: center;
								padding-left: 0px;

								img {
									width: 100px;
									height: 100px;
								}

								.p-name {
									font-size: 15px;
									font-weight: bold;
									line-height: 21px;
									color: #333333;
								}
							}
						}
					}
				}

				.order-info {
					padding: 20px;
					display: flex;
					justify-content: space-between;
					font-size: 14px;
					font-weight: 400;
					color: #666666;

					.left {
						.info {
							margin-bottom: 10px;
						}
					}

					.right {
						width: 500px;

						.top {
							border-bottom: 1px dashed #DDDDDD;
							margin-bottom: 10px;
						}

						.info:last-child {
							margin-bottom: 20px;
						}

						.info {
							display: flex;
							text-align: right;
							margin-bottom: 10px;

							.w60 {
								width: 60%;
							}

							.w40 {
								width: 40%;
							}

							.real-pay {
								font-size: 18px;
								font-weight: bold;
								color: #BE0505;
							}
						}
					}
				}
			}
		}

		.data-box {
			margin-top: 20px;

			.data-item {
				border: 1px solid #EEEEEE;
				margin-bottom: 10px;
				.header {
					height: 40px;
					line-height: 40px;
					background: #F5F5F5;
					border: 1px solid #EEEEEE;
					padding-left: 20px;
				}

				.data-content {
					display: flex;
					justify-content: space-between;
					align-items: center;

					.item {
						display: flex;

						// padding: 20px;
						.p-img {
							width: 102px;
							height: 102px;
						}

						.content:last-child {
							margin-bottom: 0px;
						}

						.content {
							margin-bottom: 10px;
							display: flex;

						}

						.content-img {
							margin-top: 20px;

							.img {
								width: 50px;
								height: 50px;
								border-radius: 5px;
								margin-right: 10px;
							}

							.img:last-child {
								margin-right: 0px;
							}
						}
					}
				}

				.wanted {
					width: 100px;
					height: 100px;
					margin: 10px;
				}
			}
		}
	}

	.title {
		font-size: 13px;
		font-weight: bold;
		color: #333333;
	}

	.value {
		margin-left: 10px;
		font-size: 13px;
		color: #666666;
		max-width: 204px;
	}

	.margin-left-10 {
		margin-left: 10px;
	}

	.padding-20 {
		padding: 20px;
	}

	.logistics {
		display: flex;
		padding: 20px;

		.left {
			width: 300px;
			display: flex;

			img {
				width: 50px;
				height: 50px;
				margin-right: 20px;
			}

			.logistics-name {
				margin-bottom: 10px;
				font-size: 14px;
				color: #666666;
			}

			.turn-list {
				.turn-item {
					width: 72px;
					height: 28px;
					margin-right: 20px;
					line-height: 28px;
					color: #999;
					border-radius: 13px;
					border: 1px solid #999;
					text-align: center;
					cursor: pointer;
					&.active {
						color: #0F114A;
						border-color: #0F114A;
					}
				}
			}
		}

		.right {
			width: 540px;
			margin-left: 50px;
			overflow: auto;

		}
	}
	.color-box{
		width: 40px;
		height: 40px;
		border-radius: 2px;
		display: inline-block;
	}
</style>
